import { Avatar } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IdentityUserDto } from '@/generated/Messages/Basic_pb'
import { generateAvatarColor } from '@/helper/generateAvatarColor'

export const useProjectDetailsUserColumns = () => {
    const { t } = useTranslation()

    return React.useMemo<GridColDef<IdentityUserDto>[]>(
        () => [
            {
                field: 'initials',
                headerName: t('user.initials'),
                valueGetter: (_, row) =>
                    `${row.firstName?.[0] ?? ''} ${row.lastName?.[0] ?? ''}`
                        .trim()
                        .toUpperCase(),
                renderCell: ({ row, value }) => {
                    const bgColor = generateAvatarColor(
                        row.firstName,
                        row.lastName,
                        row.email
                    )

                    return row.firstName || row.lastName ?
                            <Avatar sx={{ margin: 1, bgcolor: bgColor }}>
                                {value}
                            </Avatar>
                        :   null
                },
                sortable: false,
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'firstName',
                headerName: t('user.firstName'),
                flex: 1,
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'lastName',
                headerName: t('user.lastName'),
                flex: 1,
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'userName',
                headerName: t('user.userName'),
                flex: 1,
                filterable: false,
                hideable: false,
                resizable: false,
            },
        ],
        [t]
    )
}
